export default __webpack_public_path__ + "53c7294c5b206c6a911ba16923bd1bfd.svg";